// extracted by mini-css-extract-plugin
module.exports = {"root":"vacancy-page_root__IO_Qb","info":"vacancy-page_info__f3xfW","mapContainer":"vacancy-page_mapContainer__tlarA"};